module.exports = __webpack_public_path__ + "4eeefd9afda74bd10a958bb620044c99.svg";